import { Heading2 } from "@/components/podkit/typography/Headings";
import { getTemplateGroups, type AutomationTemplate } from "@/utils/automation-templates";
import { useFeatureAutomations } from "@/hooks/use-feature-automations";
import { useMemo, type FC } from "react";
import { AutomationTemplateGroup } from "@/components/automations/AutomationTemplateGroup";

type AutomationsListEmptyProps = {
    onTemplateSelect: (template: AutomationTemplate) => void;
};

export const AutomationsListEmpty: FC<AutomationsListEmptyProps> = ({ onTemplateSelect }) => {
    const { capabilities } = useFeatureAutomations();
    const groups = useMemo(() => getTemplateGroups(capabilities), [capabilities]);

    return (
        <div className="rounded-xl border border-border-subtle p-6" data-testid="workflows-empty-state">
            <Heading2 className="mb-6">Get started with an Automation template</Heading2>
            <div className="flex flex-col gap-6">
                {groups.map((group, index) => (
                    <AutomationTemplateGroup
                        key={group.id}
                        group={group}
                        index={index}
                        onTemplateSelect={onTemplateSelect}
                    />
                ))}
            </div>
        </div>
    );
};
